/**
 * @desc 通过系统单号获取列表
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(params: API.omsFlow.systemOrderContract.list.Params, options?: any) {
  return updateResponse(
    http(URL + `/systemOrderContract/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
